import styled from 'styled-components';
import { Button } from '../../input/Button';
import { Flex } from '../../layout/Flex';

export const Container = styled(Flex).withConfig({ displayName: 'Container' }).attrs({
    width: '100%',
    height: '100%',
    direction: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    px: 2,
})``;

export const DownloadButton = styled(Button).withConfig({ displayName: 'DownloadButton' }).attrs({
    width: '100%',
    spacing: 1,
    maxWidth: '310px',
})``;

export const ImageContainer = styled(Flex).withConfig({ displayName: 'ImageContainer' }).attrs({
    width: '140px',
    height: '140px',
    mt: 'auto',
    mb: 3,
})``;
